/**
 * Equipment form field keys (camelCase) — keep create/edit/inventory modals aligned.
 */
export const EQUIPMENT_PAYLOAD_KEYS = [
  'clientId',
  'siteId',
  'planId',
  'type',
  'serialNumber',
  'extinguisherType',
  'capacity',
  'inventoryNumber',
  'detailedType',
  'manufacturingDate',
  'lastMaintenanceDate',
  'nextMaintenanceDate',
  'expirationDate',
  'location',
  'detailedLocation',
  'vehicleRegistration',
  'vehicleSite',
  'vehicleType',
  'structure',
  'affectation',
  'physicalCondition',
  'spareParts',
  'firstAidKit',
  'notes',
  'observation',
  'status',
  'recoveryDate',
  'recoveredBy',
];

/** Merge partial form values onto a full equipment record for PUT (backend also merges). */
export function mergeEquipmentForUpdate(existing, partial) {
  const merged = {};
  for (const key of EQUIPMENT_PAYLOAD_KEYS) {
    if (Object.prototype.hasOwnProperty.call(partial, key)) {
      merged[key] = partial[key];
    } else if (existing && Object.prototype.hasOwnProperty.call(existing, key)) {
      merged[key] = existing[key];
    }
  }
  if (partial.type != null && partial.type !== '') {
    merged.type = partial.type;
  } else if (existing?.type) {
    merged.type = existing.type;
  }
  return merged;
}

export function addSixMonthsFromDateInput(yyyyMmDd) {
  if (!yyyyMmDd) return '';
  const m = yyyyMmDd.match(/^(\d{4})-(\d{2})-(\d{2})/);
  const d = m
    ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]))
    : new Date(yyyyMmDd);
  d.setMonth(d.getMonth() + 6);
  const y = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${mo}-${day}`;
}
